var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    d: "M7.03743 10.5562C6.75152 10.2565 6.27677 10.2453 5.97707 10.5313C5.67736 10.8172 5.66619 11.2919 5.95211 11.5916L8.09592 13.879C8.40247 14.2003 8.91955 14.1864 9.20835 13.849L13.8676 7.98514C14.137 7.67047 14.1002 7.19702 13.7856 6.92766C13.4709 6.65831 12.9974 6.69505 12.7281 7.00972L8.84911 11.9374C8.73524 12.0821 8.52567 12.107 8.38101 11.9931C8.36755 11.9826 8.35493 11.9709 8.34325 11.9584L7.03743 10.5562ZM1.66632 9.99999C1.66632 5.41666 5.41632 1.66666 9.99965 1.66666C14.583 1.66666 18.333 5.41666 18.333 9.99999C18.333 14.5833 14.583 18.3333 9.99965 18.3333C5.41632 18.3333 1.66632 14.5833 1.66632 9.99999Z",
    fill: "#28A138"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f17d8ae8e88d46a38fbf2a187d00dc8e.svg";
export { ForwardRef as ReactComponent };